import {
  accessTokenExpiration,
  accessTokenTimeLeft,
  getRoles,
  getToken,
  getUserInfo,
  initAuth,
  isAuthenticated,
  isLogged,
  logIn,
  logOut,
  refreshToken,
  refreshTokenExpiration,
  refreshTokenTimeLeft,
} from "./auth";

export function useAuthClient() {
  return {
    initAuth,
    isLogged,
    getToken,
    refreshToken,
    logIn,
    logOut,
    getRoles,
    getUserInfo,
    isAuthenticated,
    accessTokenExpiration,
    refreshTokenExpiration,
    accessTokenTimeLeft,
    refreshTokenTimeLeft,
  };
}
